import { render, staticRenderFns } from "./shuttleOldBox.vue?vue&type=template&id=174aca77&scoped=true&"
import script from "./shuttleOldBox.vue?vue&type=script&lang=ts&"
export * from "./shuttleOldBox.vue?vue&type=script&lang=ts&"
import style1 from "./shuttleOldBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174aca77",
  null
  
)

export default component.exports